import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { isElementAccessExpression } from "typescript";
import { environment } from "../../../../environments/environment";
import { AppSettings } from "../../../shared/PRE-LOAD/app-settings";
import { ReservationService } from "../../../shared/services/reservation/reservation.service";
import { Journey } from "../../../shared/types/strings.type";
import { AnalyticsService } from "../../../shared/services/analytics/analytics.service";
import { UserSelections } from "../../../shared/types/user-details.type";
import { Product } from "../../../shared/types/product.type";

@Component({
    selector: "rttd-personal-information",
    templateUrl: "./personal-information.component.html",
    styles: [
        require("./personal-information.component.scss").default.toString(),
        require(`./personal-information.component.${environment.brand}.scss`).default.toString(),
    ],
})
export class PersonalInformationComponent implements OnInit {
    // Whether or not the user details component form has valid input.
    isValid = false;
    formStarted = false;
    header: Journey = {
        title: "Book a Test Drive.",
        instruction: "Enter your booking details.",
    };
    links = {
        retailerTermsAndConditions: this.appSettings.retailerTermsAndConditions,
    };
    model?: Product;
    constructor(
        private reservationService: ReservationService,
        private router: Router,
        private appSettings: AppSettings,
        private analytics: AnalyticsService
    ) {}

    ngOnInit() {
        this.analytics.setFormStep("Personal Information");
    }

    proceed() {
        if (this.isValid) {
            this.reservationService.postReservation().subscribe((response) => {
                if (response) {
                    this.analytics.formCompleted();
                    this.router.navigate(["booking-confirmation"], {
                        skipLocationChange: true,
                        fragment: "rttd",
                    });
                }
            });
        } else {
            // this.analytics.formError()
        }
    }

    onIsValid(valid: boolean) {
        this.isValid = valid;
    }

    onValidationError(errors: any) {
        this.analytics.formError(errors);
    }
}
